module.exports = __webpack_public_path__ + "static/media/qrcode.4d17ca92.jpg";